<!-- Modern -->
 <modern-web-layout [ngClass]="[theme, scheme]" class="layoutWeb" [defaultView]="view" [lpm]="lpmConfig"></modern-web-layout>
 <div id="overlay-root" [ngClass]="[theme, scheme]"></div>